export enum UserInputOptionType {
  Contains = 1,
  StartsWith = 2,
  EndsWith = 3,
  DoesNotContain = 4,
  Equals = 5,
  DoesNotEqual = 6,
  Empty = 7,
  NotEmpty = 8,
  LessThan = 9,
  LessThanOrEqual = 10,
  GreaterThan = 11,
  GreaterThanOrEqual = 12,
  InRange = 13,
  NotInRange = 14,
}
